import { render, staticRenderFns } from "./AlertGroup.vue?vue&type=template&id=1b3d922c&scoped=true&"
import script from "./AlertGroup.vue?vue&type=script&lang=js&"
export * from "./AlertGroup.vue?vue&type=script&lang=js&"
import style0 from "./AlertGroup.vue?vue&type=style&index=0&id=1b3d922c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3d922c",
  null
  
)

export default component.exports